import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  profile: {
    cnpj: '',
    name: '',
    company_name: '',
    regional_office: '',
    profile_image_url: '',
    subsidiary_name: '',
    network_name: '',
    email: '',
    phone_number_cell: '',
    contentFavorites: []
  },
  received: false,
  fetching: false
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.RECEIVE_PROFILE: {
      return state
        .setIn(['profile'], action.payload)
        .setIn(['fetching'], false)
        .setIn(['received'], true)
    }

    case types.FETCH_PROFILE: {
      return state
        .setIn(['fetching'], action.payload)
        .setIn(['received'], !action.payload)
    }

    default: {
      return state
    }
  }
}

export default reducer
